import Api from './api.service';

export default {
  get: () => Api.get('appointments'),
  getId: (id) => Api.get(`appointments/${id}`),
  store: (data) => Api.post('appointments', data),
};
